import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTelevisionOld: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"television-old, tv, monitor, video, screen, display"} maskId="square-filled-radius-0-stroke-1-IconTelevisionOld"><path d="M7.41277 2.29883L12.0004 5.86699L16.588 2.29883L17.202 3.08818L13.4582 6H22V21H2V6H10.5426L6.79883 3.08818L7.41277 2.29883Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTelevisionOld;
